<template>
<span><span aria-hidden='true'>&nbsp;·&nbsp;</span><slot></slot></span>
</template>
